import React from 'react';
import PropTypes from 'prop-types';


const RigaDettaglioOperazione = ({
  item: {
    Id,
    Successo,
    Descrizione,
    Riferimento,
    Nota,
  },
  additionalRowData,
}) => (
  <tr key={Id}>
    <td>{Descrizione} </td>
    <td>{Successo ? 'Positivo' : 'Negativo'}</td>
    <td>{Nota}</td>
    {additionalRowData.IndicaRiferimenti && <td> {Riferimento}</td>}
  </tr>
);

RigaDettaglioOperazione.propTypes = {
  item: PropTypes.object.isRequired,
  additionalRowData: PropTypes.object.isRequired,
};

export default RigaDettaglioOperazione;
